import { WizardButton } from '@iheartjane/menu';
import type { ComponentProps } from 'react';
import { useEffect } from 'react';

import { useWizardExposure } from './wizardExposureContext';

export function BloomWizardButton(props: ComponentProps<typeof WizardButton>) {
  const { markExposed } = useWizardExposure();

  useEffect(() => {
    markExposed();
  }, [markExposed]);

  return <WizardButton {...props} />;
}
